export default function ArticleImage({
  article,
  className = "",
  sizes = "(max-width: 719px) calc(100vw - 32px), 680px",
}) {
  if (!article?.image) return null;
  const credit = article.imageCredit;
  const creditRel = article.sponsoredDisclosure ? "sponsored noopener noreferrer" : "noopener noreferrer";
  return (
    <figure className={"editorial-article-media " + className}>
      <picture>
        {article.imageWebpSrcSet && <source type="image/webp" srcSet={article.imageWebpSrcSet} sizes={sizes} />}
        <img
          src={article.image}
          srcSet={article.imageSrcSet || undefined}
          sizes={article.imageSrcSet ? sizes : undefined}
          alt={article.imageAlt || article.title || ""}
          width={article.imageWidth || 1200}
          height={article.imageHeight || 630}
          loading="eager"
          decoding="async"
          fetchpriority="high"
        />
      </picture>
      {(article.imageCaption || credit) && (
        <figcaption>
          {article.imageCaption && <span>{article.imageCaption} </span>}
          {credit && <span>Image credit {credit.url ? <a href={credit.url} rel={creditRel}>{credit.name}</a> : credit.name}{credit.license && <> · <a href={credit.licenseUrl || credit.url} rel={creditRel}>{credit.license}</a></>}</span>}
        </figcaption>
      )}
    </figure>
  );
}
